import styled from "@emotion/styled";
import Title from "./title";

export const StyledMarkdown = styled.div`
  line-height: 1.5rem;

  & *:last-child {
    margin-bottom: 0;
  }
`;

export const StyledMDTitle = styled(Title)`
  margin-top: 2rem;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const StyledMDParagraph = styled.div`
  margin-bottom: 1rem;
`;

export const StyledMDStrong = styled.span`
  font-weight: 700;
`;

export const StyledMDUl = styled.ul``;

export const StyledMDOl = styled.ol``;

export const StyledMDLi = styled.li``;

export const StyledA = styled.a``;
